import {DeployProperty} from "./deploy-property";
import {DisplaySystemProperty} from "./display-system-property";
import {TutorialBase} from "./tutorial-base";

export class SystemProperties extends TutorialBase {
  public customTheme: string;
  public deployProperties: DeployProperty[];
  public footer: any;
  public siteName: any;
  public delimiter: any;
  public decimalSeparator: any;
  public displaySystemProperties: DisplaySystemProperty[];
  public bpaProperties: any;
  public homepageUrl: any;
  public aiModelName: any;
  public aiExtractionEndpoint: any = "Sparrow.POST/extract_data_sparrow";
}
